/**
 * useMgConfig
 *
 * Created by Samuel on 2022/5/16
 */
import { useContext } from 'react';

import { ConfigContext } from '../configProvider';

export function useConfig() {
	return useContext(ConfigContext);
}
